import { STAFF_CALENDAR } from "@/api_framework/api_config";
import { ICalendarProps, IStaffCalendarFilterDataResponse } from "@/api_framework/api_modals/Calendar";
import { useAppDispatch } from "@/app_redux/hooks/root_hook";
import { setLoading } from "@/app_redux/reducers/loading_reducer";
import { setRotaerrorIds } from "@/app_redux/reducers/slices/auth/rota_slice";
import { setCalendarData } from "@/app_redux/reducers/slices/auth/staff_calendar_slice";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback } from "react";
import toast from "react-hot-toast";
import { useConfiguration } from "../../useConfiguration";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";

AxiosCurlirize(axios, () => {});
export type RotaCreationReturnType = {
  status: boolean;
  message: string;
};

export const useStaffCalendarFilterAPI = () => {
  const configuration = useConfiguration();

  const dispatch = useAppDispatch();
  const { sendCurl } = useCurlLogger();
  const execute = useCallback(
    async (filterParams: ICalendarProps) => {
      dispatch(
        setLoading({
          key: "isStaffCalendarLoadingInProgress",
          status: true,
        }),
      );
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: RotaCreationReturnType = await axios
          .post(STAFF_CALENDAR?.STAFF_FILTER_API?.baseURL ?? "", filterParams, {
            headers: {
              Authorization: `${accessToken}`,
              "Content-Type": "application/json",
            },
          })
          .then((res: AxiosResponse<IStaffCalendarFilterDataResponse>) => {
            if (res.data.status === true) {
              dispatch(
                setCalendarData({
                  data: res.data.data,
                }),
              );
              dispatch(
                setLoading({
                  key: "isStaffCalendarLoadingInProgress",
                  status: false,
                }),
              );
              return { status: true, message: "ROTA_CREATED" };
            } else {
              dispatch(
                setCalendarData({
                  data: [],
                }),
              );
              dispatch(
                setLoading({
                  key: "isStaffCalendarLoadingInProgress",
                  status: false,
                }),
              );
              return { status: false, message: "ROTA_NOT_CREATED" };
            }
          })
          .catch((e: AxiosError) => {
            sendCurl(e.config["curlCommand"]);
            const vv = e.response.data as any;
            if (e.response.status === 400) {
              dispatch(setRotaerrorIds({ data: vv }));
              toast.error("Error while  Fetching Slots Details");
              dispatch(
                setCalendarData({
                  data: [],
                }),
              );
              return { status: false, message: vv.message };
            }
            if (e.response.status === 500) {
              toast.error("Server error 500");
              dispatch(
                setCalendarData({
                  data: [],
                }),
              );
              dispatch(
                setLoading({
                  key: "isStaffCalendarLoadingInProgress",
                  status: false,
                }),
              );
              return { status: false, message: vv.message };
            }
          });
        return response;
      } catch (e: any) {
        const vv = e.response.data as any;

        toast.error("Server Error: " + e.message);

        return { status: false, message: vv.message };
      }
    },
    [dispatch],
  );
  return execute;
};
